import { NbJSThemeOptions } from '@nebular/theme';
import { DEFAULT_THEME } from './theme.default';

export const STARTBAHN27_THEME = {
  name: 'startbahn27_default',
  base: 'default',
  // We could override this in the future
  variables: DEFAULT_THEME.variables,
} as NbJSThemeOptions;
